import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'lift_c1_traumatic',
    label: 'LIFT_C1_Traumatic',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
